<template>
<div id="signup" class="container small">
    <report-background />
    <div class="blur-background"></div>
    <div class="page-container">
        <div class="main-content-wrapper">
            <div class="logo">
                <img class="header-icons" src="/assets/images/Autobahn_horizontal_combination_mark_white.png" alt="fitness-icon-hero" height="38">
            </div>
            <div class="card-container">
                <component
                    :is="cards[cardIndex]"
                    @verify_account="verifyAccount"
                    :emailToVerify="emailToVerify"
                    :checkedPassword="checkedPassword"
                    :userData="userData"
                    @next_index="nextIndex"
                    @updateModal="updateModal">
                </component>
            </div>
        </div>
    </div>
</div>
</template>

<script>
// eslint-disable-next-line import/extensions
import '~/assets/js/global.js';
import SignupCard from './cards/signup.vue';
import ProfileCard from './cards/profile.vue';
import JoinOrCreateCard from './cards/join-or-create.vue';
import VerifyCard from './cards/verify.vue';
import ReportBackground from './report/report.vue';
import Navbar from '~/components/shared/templates/navbar.vue';
import CreateProfileCard from './cards/create-profile.vue';
import Heading from '~/components/shared/heading.vue';
import Paragraph from '~/components/shared/paragraph.vue';
import TextStyle from '~/components/shared/text-style.vue';
import ListRow from '~/components/shared/list-row.vue';

export default {
    components: {
        Navbar,
        SignupCard,
        ProfileCard,
        JoinOrCreateCard,
        VerifyCard,
        CreateProfileCard,
        Heading,
        Paragraph,
        TextStyle,
        ListRow,
        ReportBackground,
    },
    data() {
        return {
            cards: ['signup-card', 'profile-card', 'join-or-create-card', 'verify-card'],
            cardIndex: 0,
            emailToVerify: '',
            checkedPassword: '',
            finished: false,
            userData: {},
        };
    },
    mounted() {
        if (window.location.hash) {
            // eslint-disable-next-line radix
            const card = parseInt(window.location.hash.split('#')[1]);
            if (card >= 0) {
                this.cardIndex = card;
            }
        }
    },
    computed: {
        big() {
            return this.cardIndex === 2 && !this.finished;
        },
    },
    methods: {
        verifyAccount(confirmed) {
            // eslint-disable-next-line prefer-destructuring
            this.emailToVerify = confirmed[0];
            // eslint-disable-next-line prefer-destructuring
            this.checkedPassword = confirmed[1];
            this.nextIndex(3);
        },
        nextIndex(newIndex) {
            this.cardIndex = newIndex;
        },
    },
};
</script>

<style lang="scss">
@import "global/default";
@import '~/scss/pages/signup.scss';
</style>
